import { SVGProps } from 'react'

const SvgGrayTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.54927 9.51503L14.1878 0.876532C14.3364 0.727699 14.5104 0.651699 14.7098 0.648533C14.9091 0.645366 15.0864 0.721366 15.2415 0.876532C15.3967 1.0317 15.4743 1.20987 15.4743 1.41103C15.4743 1.61237 15.3967 1.79061 15.2415 1.94578L6.18202 11.0208C6.00119 11.2014 5.79027 11.2918 5.54927 11.2918C5.30827 11.2918 5.09736 11.2014 4.91652 11.0208L0.741524 6.84578C0.592858 6.69695 0.519524 6.52028 0.521524 6.31578C0.523358 6.11145 0.601857 5.9317 0.757024 5.77653C0.912191 5.62137 1.09036 5.54378 1.29152 5.54378C1.49286 5.54378 1.67111 5.62137 1.82627 5.77653L5.54927 9.51503Z"
      fill="#666666"
    />
  </svg>
)
export default SvgGrayTick
